import useApi, { ApiOptions } from '../base/useApi';
import ConsultantDTO from '@src/adapters/dto/consultant/ConsultantDTO';
interface Params {
  consultant: ConsultantDTO;
}

interface Result {
  consultant: ConsultantDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/consultant',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useSaveConsultant = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveConsultantLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveConsultant;
